import React from 'react';
import { string, oneOf } from 'prop-types';
import styles from './styles/styles.module.scss';

const photoRoot = 'https://cdn-assets.alltrails.com/assets/images/gifting';

const GiftCard = ({ backgroundId, classes }) => {
  const background = `url(${photoRoot}/${backgroundId}.png)`;

  return <div style={{ background }} className={`${styles.cardContainer} ${classes}`} />;
};

GiftCard.propTypes = {
  backgroundId: string.isRequired,
  classes: string
};

GiftCard.defaultProps = {
  classes: ''
};

export default GiftCard;
